import _ from 'lodash'
import moment from 'moment'
import StaticValue from '@/modules/common/values/staticValue'

export const normalize = (value?: string) => {
  return (value || '').toLowerCase().normalize('NFD').replace(/[^\w]/g, '')
}

export const enumToStaticValue = (sourceEnum: any, enumName: string) => {
  const value = _(sourceEnum).keys().map(enumValue => new StaticValue(enumValue, `value.${enumName}.label.${enumValue}`)).value()
  return value
}

export const FORMAT_DATE_TIME = (value?: moment.Moment) => {
  return value ? moment(value).format('DD.MM.YYYY HH:mm') : null
}
